import styled from 'styled-components'

export const ButtonLocal = styled.button`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 20px;
  cursor: pointer;
`

export const Text = styled.div`
  font-weight: 600;
  margin-top: 8.5px;
  font-size: 1em;
  line-height: 18px;
  color: #3249d7;
`
